import { createFileRoute } from '@tanstack/react-router';

// relative imports
import Loader from '../../../../../../components/shared/custom-components/Loader';
import WalletImport from '../../../../../../components/source-management/wallets/wallet-page/wallet-import/WalletImport';

export type ImportSearch = {
  importId?: String;
};

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/$walletId/_wallet/imports',
)({
  validateSearch: (search: Record<string, unknown>): ImportSearch => ({
    importId: search.importId as String,
  }),
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: WalletImport,
  beforeLoad: () => ({ sourceType: 'wallet' }),
});
